
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Database, AlertTriangle, CheckCircle, RefreshCw } from "lucide-react";
import { AffiliateBackfillConsole } from '@/components/admin/affiliate/AffiliateBackfillConsole';
import { DataConsistencyReport } from '@/components/admin/affiliate/DataConsistencyReport';
import { BackfillProgressTracker } from '@/components/admin/affiliate/BackfillProgressTracker';

const AffiliateBackfillPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-3">
          <Database className="h-8 w-8 text-primary" />
          Affiliate Data Backfill Tool
        </h1>
        <p className="text-muted-foreground mt-2">
          Công cụ backfill và đồng bộ dữ liệu affiliate system
        </p>
      </div>

      {/* Warning Banner */}
      <Card className="border-amber-200 bg-amber-50">
        <CardHeader className="pb-3">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
            <CardTitle className="text-amber-800">Cảnh báo quan trọng</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-0">
          <p className="text-amber-700 text-sm">
            Tool này sẽ thực hiện các thay đổi quan trọng đến database. Vui lòng backup dữ liệu trước khi chạy.
            Các thao tác bao gồm: sync referred_by_affiliate, backfill user limits, và validate data consistency.
          </p>
        </CardContent>
      </Card>

      {/* Progress Tracker */}
      <BackfillProgressTracker />

      {/* Data Consistency Report */}
      <DataConsistencyReport />

      {/* Backfill Console */}
      <AffiliateBackfillConsole />
    </div>
  );
};

export default AffiliateBackfillPage;
